import React from 'react';
import { PageBanner } from '../components/PageBanner';
import { Gallery } from '../components/Gallery';
import { CtaBanner } from '../components/CtaBanner';
import { CLEANING_IMAGES } from '../constants/images';
export function GalleryPage() {
  return <>
      <PageBanner title="Real spaces. Real sparkle." subtitle="A look at the meticulous results we deliver in homes and offices across Clifton, NJ." backgroundImage={CLEANING_IMAGES[10]} breadcrumb="Gallery" data-id="element-490" />
      <Gallery data-id="element-491" />
      <CtaBanner data-id="element-492" />
    </>;
}